// extracted by mini-css-extract-plugin
module.exports = {"container":"HydrogenStorage_container__DqOjO","storageTable":"HydrogenStorage_storageTable__5nd-p","storageTank":"HydrogenStorage_storageTank__3v965"};